export default __webpack_public_path__ + "static/media/sales.3111aad4.webp";